exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-red input {\n  background-color: transparent;\n  color: white;\n  outline: none;\n  border: none;\n  box-shadow: none;\n  font-size: 16px; }\n\n.btn-secondary0 {\n  font-size: 16px; }\n\n.title-status {\n  background-color: #CED2DD; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/status/status-new/status-new.component.scss
// module id = ../../../../../src/app/admin/status/status-new/status-new.component.scss
// module chunks = status.module